import { customizeValidator } from "@rjsf/validator-ajv8";

// Create a custom validator with support for "tel" format
const validator = customizeValidator({
  customFormats: {
    tel: (value: string) => {
      // Validate telephone number - allow digits, spaces, hyphens, plus signs, parentheses
      // This is a basic validation pattern for international phone numbers
      const telPattern = /^[\+]?[(]?[\d\s\-\(\)]{1,12}$/;
      return telPattern.test(value);
    },
  },
});

export default validator;